import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { configSelector } from '../../../selectors/configSelector';
import { TThunkDispatch } from '../../../types/redux';
import { newbuildingChatOpenToggle } from '../../state/newbuildingConsultant';
import { NewbuildingConsultTopBanner } from './NewbuildingConsultTopBanner';

export function NewbuildingConsultTopBannerContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const open = React.useCallback(() => dispatch(newbuildingChatOpenToggle(true)), [dispatch]);

  const config = useSelector(configSelector);

  const phone = config.get<string>('newbuildingConsultant.phone.moscowAndRegion');

  return <NewbuildingConsultTopBanner onChatClick={open} phone={phone} />;
}
